module.exports = __webpack_public_path__ + "img/no-image-placeholder.fa8e4dc3.png";